module.exports = __webpack_public_path__ + "img/swiper_left_hover.0442942d.svg";